import { render, staticRenderFns } from "./CreateVehicleDialog.vue?vue&type=template&id=4a5450a7&scoped=true"
import script from "./CreateVehicleDialog.vue?vue&type=script&lang=ts"
export * from "./CreateVehicleDialog.vue?vue&type=script&lang=ts"
import style0 from "./CreateVehicleDialog.vue?vue&type=style&index=0&id=4a5450a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5450a7",
  null
  
)

export default component.exports